import { render, staticRenderFns } from "./RPagination.vue?vue&type=template&id=5146b6c6&scoped=true&"
import script from "./RPagination.vue?vue&type=script&lang=js&"
export * from "./RPagination.vue?vue&type=script&lang=js&"
import style0 from "./RPagination.vue?vue&type=style&index=0&id=5146b6c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5146b6c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
